module.exports = __webpack_public_path__ + "img/phone_call.6c64dcfd.svg";